export const BASEURL = process.env.REACT_APP_BASE_URL || 'http://localhost:8088/api';

export const TRACKER_API_BASE = process.env.REACT_APP_TRACKER_API_URL || 'https://tracker-api.thepsm.app/api';

const token = window.localStorage.getItem('auth-token');
export const headers = {
  'x-auth-token': `${token}`,
};
